module.exports = __webpack_public_path__ + "static/scopriabitareco_valori_2_coraggio-90305552c88f633b3186c975be30a6a7.jpg";